module.exports = __webpack_public_path__ + "static/img/9.7733f34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/9.png
// module id = hBkv
// module chunks = 0